import { render, staticRenderFns } from "./Giphy.vue?vue&type=template&id=5fe8a336&"
import script from "./Giphy.vue?vue&type=script&lang=js&"
export * from "./Giphy.vue?vue&type=script&lang=js&"
import style0 from "./Giphy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VFlex,VLayout,VProgressCircular})


/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fe8a336')) {
      api.createRecord('5fe8a336', component.options)
    } else {
      api.reload('5fe8a336', component.options)
    }
    module.hot.accept("./Giphy.vue?vue&type=template&id=5fe8a336&", function () {
      api.rerender('5fe8a336', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GroupTeams/Common/Games/Giphy.vue"
export default component.exports